// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2bGop","boxTitle":"Qualiphy_boxTitle__sRjV5","box":"Qualiphy_box__15ufu","toggleWrap":"Qualiphy_toggleWrap__1ZvKD"};